import React from 'react'
import { Flex, Avatar, Text } from '@chakra-ui/react'
import { ChevronDownIcon, ChevronUpIcon } from '@chakra-ui/icons'

import { capitalizeByWord } from 'utils/functions/formatString'
import { IStyles, IStyle } from './UserInfo.d'

interface IUserInfoProps {
  userName: string
  companyName: string
  isActive?: boolean
}

const UserInfo: React.FC<IUserInfoProps> = ({ userName, companyName, isActive = false }) => {
  const styles: IStyles = {
    active: {
      avatarBg: 'tertiary.20',
      avatarBorder: 'tertiary.300',
      avatarContent: 'tertiary.400',
      contentColor: 'tertiary.800',
    },
    inactive: {
      avatarBg: 'primary.500',
      avatarBorder: 'primary.500',
      avatarContent: 'white',
      contentColor: 'grey.120',
    }
  }

  const currentStyle: IStyle = isActive ? styles.active : styles.inactive

  return (
    <Flex flexDir='column'>
      <Flex flexDir='row' alignItems='center' data-testid='menu-button' role='menu'>
        <Flex>
          <Avatar
            size='md'
            bg={currentStyle.avatarBg}
            color={currentStyle.avatarContent}
            showBorder
            borderColor={currentStyle.avatarBorder}
            name={userName}
          />
        </Flex>
        <Flex flexDir='column' marginLeft={4} data-testid='user-data'>
          <Text textStyle='titleSmBold'>{capitalizeByWord(userName || '')}</Text>
          <Text textStyle='labelMd'>{companyName || 'Empresa'}</Text>
        </Flex>
        <Flex ml={4} data-testid='chevron' marginLeft={4}>
          {isActive ? <ChevronUpIcon w='18px' h='18px' data-testid='chevron-up' /> : <ChevronDownIcon w='18px' h='18px' data-testid='chevron-down' />}
        </Flex>
      </Flex>
    </Flex>

  )
}

export default UserInfo
